"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMemoize = useMemoize;
exports.default = void 0;

var _glamor = require("glamor");

var _reactScrollToBottom = require("react-scroll-to-bottom");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _BasicTypingIndicator = _interopRequireDefault(require("./BasicTypingIndicator"));

var _ScrollToEndButton = _interopRequireDefault(require("./Activity/ScrollToEndButton"));

var _Speak = _interopRequireDefault(require("./Activity/Speak"));

var _useActivities3 = _interopRequireDefault(require("./hooks/useActivities"));

var _useDirection3 = _interopRequireDefault(require("./hooks/useDirection"));

var _useRenderActivity = _interopRequireDefault(require("./hooks/useRenderActivity"));

var _useRenderAttachment = _interopRequireDefault(require("./hooks/useRenderAttachment"));

var _useStyleOptions3 = _interopRequireDefault(require("./hooks/useStyleOptions"));

var _useStyleSet3 = _interopRequireDefault(require("./hooks/useStyleSet"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var ROOT_CSS = (0, _glamor.css)({
  overflow: 'hidden',
  position: 'relative'
});
var PANEL_CSS = (0, _glamor.css)({
  display: 'flex',
  flexDirection: 'column',
  WebkitOverflowScrolling: 'touch'
});
var FILLER_CSS = (0, _glamor.css)({
  flex: 1
});
var LIST_CSS = (0, _glamor.css)({
  listStyleType: 'none'
});

function useMemoize(fn) {
  return (0, _react.useMemo)(function () {
    var cache = [];
    return function (run) {
      var nextCache = [];
      var result = run(function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _ref = [].concat(_toConsumableArray(cache), nextCache).find(function (_ref2) {
          var cachedArgs = _ref2.args;
          return args.length === cachedArgs.length && args.every(function (arg, index) {
            return Object.is(arg, cachedArgs[index]);
          });
        }) || {
          result: fn.apply(void 0, args)
        },
            result = _ref.result;

        nextCache.push({
          args: args,
          result: result
        });
        return result;
      });
      cache = nextCache;
      return result;
    };
  }, [fn]);
}

var BasicTranscript = function BasicTranscript(_ref3) {
  var className = _ref3.className;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      _useStyleSet2$ = _useStyleSet2[0],
      activitiesStyleSet = _useStyleSet2$.activities,
      activityStyleSet = _useStyleSet2$.activity;

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      hideScrollToEndButton = _useStyleOptions2[0].hideScrollToEndButton;

  var _useActivities = (0, _useActivities3.default)(),
      _useActivities2 = _slicedToArray(_useActivities, 1),
      activities = _useActivities2[0];

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  var renderAttachment = (0, _useRenderAttachment.default)();
  var renderActivity = (0, _useRenderActivity.default)(renderAttachment);
  var renderActivityElement = (0, _react.useCallback)(function (activity, nextVisibleActivity) {
    return renderActivity({
      activity: activity,
      nextVisibleActivity: nextVisibleActivity
    });
  }, [renderActivity]);
  var memoizeRenderActivityElement = useMemoize(renderActivityElement);
  var activityElementsWithMetadata = (0, _react.useMemo)(function () {
    return memoizeRenderActivityElement(function (renderActivityElement) {
      var _reverse$reduce = _toConsumableArray(activities).reverse().reduce(function (_ref4, activity, index) {
        var nextVisibleActivity = _ref4.nextVisibleActivity,
            result = _ref4.result;
        var element = renderActivityElement(activity, nextVisibleActivity); // Until the activity passes through middleware, it is unknown whether the activity will be visible.
        // If the activity does not render, it will not be spoken if text-to-speech is enabled.

        if (element) {
          result = [{
            activity: activity,
            element: element,
            key: activity.channelData && activity.channelData.clientActivityID || activity.id || index,
            // TODO: [P2] #2858 We should use core/definitions/speakingActivity for this predicate instead
            shouldSpeak: activity.channelData && activity.channelData.speak
          }].concat(_toConsumableArray(result));
          nextVisibleActivity = activity;
        }

        return {
          nextVisibleActivity: nextVisibleActivity,
          result: result
        };
      }, {
        nextVisibleActivity: undefined,
        result: []
      }),
          activityElementsWithMetadata = _reverse$reduce.result;

      return activityElementsWithMetadata;
    });
  }, [activities, memoizeRenderActivityElement]);
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(ROOT_CSS + '', className + ''),
    dir: direction,
    role: "log"
  }, _react.default.createElement(_reactScrollToBottom.Panel, {
    className: PANEL_CSS + ''
  }, _react.default.createElement("div", {
    className: FILLER_CSS
  }), _react.default.createElement("ul", {
    "aria-atomic": "false",
    "aria-live": "polite",
    "aria-relevant": "additions text",
    className: (0, _classnames.default)(LIST_CSS + '', activitiesStyleSet + ''),
    role: "list"
  }, activityElementsWithMetadata.map(function (_ref5) {
    var activity = _ref5.activity,
        element = _ref5.element,
        key = _ref5.key,
        shouldSpeak = _ref5.shouldSpeak;
    return _react.default.createElement("li", {
      // Because of differences in browser implementations, aria-label=" " is used to make the screen reader not repeat the same text multiple times in Chrome v75 and Edge 44
      "aria-label": " ",
      className: activityStyleSet + '',
      key: key,
      role: "listitem"
    }, element, shouldSpeak && _react.default.createElement(_Speak.default, {
      activity: activity
    }));
  })), _react.default.createElement(_BasicTypingIndicator.default, null)), !hideScrollToEndButton && _react.default.createElement(_ScrollToEndButton.default, null));
};

BasicTranscript.defaultProps = {
  className: ''
};
BasicTranscript.propTypes = {
  className: _propTypes.default.string
};
var _default = BasicTranscript;
exports.default = _default;